import { LEVEL_WORKER, RANK_CONSISTENCY_STATUS } from './constants';
import _ from 'lodash';
import { messageUtility } from './messageUtility';

export const getRankConsistencyStatusName = value => {
  const result = _.find(RANK_CONSISTENCY_STATUS, { value });
  if (result) {
    return result.name;
  }
  return '';
};

export const getColorRankConsistencyStatusName = status => {
  let colorText = '';
  if (status === RANK_CONSISTENCY_STATUS['NOT_MATCHING'].value) {
    colorText = 'text--negative';
  } else if (status === RANK_CONSISTENCY_STATUS['MATCHING'].value) {
    colorText = 'text--effective';
  }
  return colorText;
};

export const getMessageRankConsistencyStatus = status => {
  switch (status) {
    case RANK_CONSISTENCY_STATUS.UN_CONFIRM.value:
      return messageUtility.getMessage('I-000-214');
    case RANK_CONSISTENCY_STATUS.MATCHING.value:
      return messageUtility.getMessage('I-000-215');
    case RANK_CONSISTENCY_STATUS.NOT_MATCHING.value:
      return messageUtility.getMessage('I-000-216');
    default:
      return '';
  }
};

export const getLevelWorkerName = rank_name_code => {
  const data = _.find(LEVEL_WORKER, { rank_name_code });
  if (data) {
    return `${data['rank_name']}（${data['rank_color']}）`;
  }
  return '';
};

export const convertRankNameLevel = rank_name_code => {
  const result = _.find(LEVEL_WORKER, { rank_name_code });
  if (result) {
    return result.rank_name;
  }
  return '';
};

export const checkNotMatchingRankNameCode = rank_consistency_status => {
  if (
    rank_consistency_status === RANK_CONSISTENCY_STATUS.NOT_MATCHING.value ||
    rank_consistency_status === RANK_CONSISTENCY_STATUS.UN_CONFIRM.value
  ) {
    return true;
  }
  return false;
};



// WEBPACK FOOTER //
// ./src/utilities/workerUtil.js